import { render, staticRenderFns } from "./ProductCategoryCollapseItem.vue?vue&type=template&id=73596a78&"
import script from "./ProductCategoryCollapseItem.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryCollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports